import React from "react";
import { Sparkles, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ComingSoon({ title, description, icon: Icon = Sparkles }) {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-2xl">
      <div className="card-elevated p-10 lg:p-14 text-center relative overflow-hidden">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-accent/10 text-accent">
          <Icon className="h-7 w-7" />
        </div>
        <div className="mt-6 text-overline">Prochainement</div>
        <h2 className="mt-2 font-serif text-3xl sm:text-4xl text-foreground">{title}</h2>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          {description || "Ce module est en cours de développement. Il rejoindra prochainement votre espace Fonbex."}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button className="btn-pill" onClick={() => navigate("/app/dashboard")}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Retour au tableau de bord
          </Button>
        </div>
      </div>
    </div>
  );
}
